import React, {useRef, useState} from "react";
import styled from "styled-components";
import media from "styled-media-query";
import breakpoints from "Helpers/BreakpointHelper";
import {getDreambrokerVideo, getYoutubeVideo} from "Helpers/VideoHelper";

export const Video = ({
                          VideoType,
                          Heading,
                          VideoLink,
                          Image,
                          Description,
                          videoHeight,
                          useTwoColumnLayout = false,
                          isBlock = false
                      }) => {
    const [videoUrl, setVideoUrl] = useState("");
    const videoRef = useRef();
    const handleClick = () => {
        switch (VideoType) {
            case "youtube":
                setVideoUrl(getYoutubeVideo(VideoLink));
                break;
            case "dreambroker":
                setVideoUrl(getDreambrokerVideo(VideoLink));
                break;
        }
        videoRef.play;
    };

    return (
        <VideoWrapper>
            <Thumbnail bgImage={Image} height={videoHeight}
                       useTwoColumnLayout={useTwoColumnLayout}>
                <VideoButton onClick={handleClick}>
                    <i className="icon-play"></i>
                </VideoButton>
                {Heading && <Header isBlock={isBlock}>{Heading}</Header>}
            </Thumbnail>
            {videoUrl && (
                <VideoIframe
                    className={'videoIframe'}
                    videoType={VideoType}
                    frameBorder="0"
                    allow="autoplay *;"
                    title="video"
                    ref={videoRef}
                    src={videoUrl}
                    height={videoHeight}
                    useTwoColumnLayout={useTwoColumnLayout}
                    isBlock={isBlock}
                />
            )}
            {Description && <VideoDescription dangerouslySetInnerHTML={{
                __html: Description,
            }}></VideoDescription>}
        </VideoWrapper>
    );
};


export const VideoDescription = styled.div`
    font-size: 20px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;

    p {
        margin: 0;
    }
`;
export const VideoWrapper = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    position: relative;
    gap: 10px;
`;
const VideoIframe = styled.iframe`
    width: 100%;
    position: absolute;
    height: ${({
                   useTwoColumnLayout,            
                   height
               }) => height !== undefined ? height : useTwoColumnLayout ? "219px" : "450px"};
    ${media.lessThan(breakpoints.ipad)`
			 height: ${({
                                                                   useTwoColumnLayout,
                                                                   height
                                                               }) => height !== undefined ? height : useTwoColumnLayout ? "219px" : "450px"};
		`}
    ${media.lessThan(breakpoints.mobile)`
				 height: ${({
                                                                         height
                                                                     }) => height !== undefined ? height : "450px"};
		`}
`;
export const VideoButton = styled.button`
    width: 60px;
    height: 60px;
    align-self: center;
    background-color: rgba(255, 255, 255, 0.9);
    padding: 19px 19px 18.1px 21px;
    border-radius: 50px;
    display: flex;
    border: none;
    align-items: center;
    cursor: pointer;

    justify-content: center;

    &:hover {
        i {
            transition: 0.2s ease;

            color: black;
        }
    }

    i {
        margin-left: 5px;

        transition: 0.2s ease;

        font-size: 40px;
        color: ${({theme}) => theme.colors.iconColor};
    }
`;

const Thumbnail = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    height: ${({useTwoColumnLayout, height}) => height !== undefined ? height : useTwoColumnLayout ? "219px" : "450px"};
    /* align-items: center; */
    justify-content: center;
    background-image: ${({bgImage}) =>
            bgImage
                    ? `url(${bgImage})`
                    : `url("/media/0oih55qs/frosunda1.png?anchor=center&mode=crop&rnd=132507344321470000")`};

    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    ${media.lessThan(breakpoints.mobile)`
				 height: ${({
                                                                         height
                                                                     }) => height !== undefined ? height : "450px"};
		`}
`;
const Header = styled.span.attrs(({isBlock}) => ({
    as: isBlock ? "" : "h1",
}))`
    background-color: #ffffff;
    position: absolute;
    top: 60%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    padding: ${({isBlock}) => (isBlock ? "2px 5px" : "0 20px")};
    font-size: ${({isBlock}) => (isBlock ? "16px" : "30px")};

    margin: ${({isBlock}) => (isBlock ? "20px 10px 0 10px" : "30px 0 0 30px")};

    h1 {
        margin: 0;
        font-size: 80px;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.67;
        letter-spacing: normal;
        text-align: left;
        color: #1e1e1e;
    }
`;
